import { render, staticRenderFns } from "./point_mall_detail.vue?vue&type=template&id=7d0915de&scoped=true"
import script from "./point_mall_detail.vue?vue&type=script&lang=js"
export * from "./point_mall_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0915de",
  null
  
)

export default component.exports